'use strict';
import template from './mx-grid-selection-picker.component.html';

export class MxGridSelectionPickerCtrl {
	static $inject = ['$element', '$timeout', 'mx.SolutionBuilderAgent.DialogOpenerService'];

	constructor($element, $timeout, dialogOpenerService) {
		Object.assign(this, {
			$element,
			$timeout,
			dialogOpenerService,
		});
		this.elementHeight = 0;
	}

	$onInit() {
		this.grid.executor.addSelectionHandler(this.onSelectionChanged.bind(this));
	}

	onChipDblClick(row) {
		this.dialogOpenerService.openPreview(row.getEntity(), undefined, undefined, this.parentViewController && this.parentViewController.mxView);
	}

	onChipRemoveClick(row) {
		this.grid.executor.toggleRowSelection(row);
	}

	getDisplayNameFromChip(row) {
		return row.getEntity()._displayName;
	}

	onSelectionChanged() {
		this.$timeout(() => {
			if (this.elementHeight !== this.$element[0].offsetHeight) {
				this.elementHeight = this.$element[0].offsetHeight;
				this.onHeightChanged({ height: this.elementHeight });
			}
		});
	}
}

export default {
	bindings: {
		grid: '<',
		onHeightChanged: '&',
	},
	require: {
		parentViewController: '?^^mxView',
	},
	controller: MxGridSelectionPickerCtrl,
	controllerAs: 'vm',
	template: template,
};
